<template>
    <div :class="$style.root">
        <h2>
            <slot>页面标题</slot>
            <svg width="80" height="60">
                <path d="M0,0Q30,0,40,30q10,30,40,30l-80,0" stroke-opacity="0" fill="#0a4c5a"></path>
                <path d="M0,0Q30,0,40,30q10,30,40,30" stroke="#10aca9" stroke-width="1.4" fill-opacity="0"></path>
            </svg>
        </h2>
        <h1>欢迎登录无人机电力巡线系统</h1>
    </div>
</template>

<script>
    export default {
        name: 'PageTitle',
    };
</script>


<style lang="less" module>
    @import "../styles/variables";

    .root {
        position: fixed;
        top: 21px;
        margin-left: -11px;
        color: #00ddd1;
        display: flex;

        h1 {
            font-size: 20px;
            color: #09a69d;
            margin-left: 80px;
            height: @header-height;
            line-height: @header-height;
        }

        h2 {
            font-size: 16px;
            color: inherit;
            padding: 0 20px 0 40px;
            height: @header-height;
            line-height: @header-height;
            background-color: @page-bg-color;
            border: 1px solid @page-border-color;
            border-right: 0;
            border-bottom: 0;
            border-radius: 24px 2px 0 0;
            position: relative;

            svg {
                position: absolute;
                right: -74px;
                top: -1px;
            }
        }
    }
</style>
